module.exports = __webpack_public_path__ + "media/play_event_badge.026b490b.mp3";